var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempLabour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62596 4.06907C6.31349 4.27865 5.15594 4.95255 4.32704 5.91706C3.13357 5.61687 2.25 4.53662 2.25 3.25C2.25 1.73122 3.48122 0.5 5 0.5C6.51878 0.5 7.75 1.73122 7.75 3.25C7.75 3.53525 7.70657 3.81036 7.62596 4.06907ZM3.59971 7C3.21628 7.75007 3 8.59978 3 9.5C3 10.8095 3.45766 12.0122 4.22176 12.9567C1.55468 12.653 0 10.8026 0 9V8.5C0 7.67157 0.671573 7 1.5 7H3.59971ZM8.5 14C10.9853 14 13 11.9853 13 9.5C13 7.01472 10.9853 5 8.5 5C6.01472 5 4 7.01472 4 9.5C4 11.9853 6.01472 14 8.5 14ZM8.5 7C8.77614 7 9 7.22386 9 7.5V9H10.5C10.7761 9 11 9.22386 11 9.5C11 9.77614 10.7761 10 10.5 10H9V11.5C9 11.7761 8.77614 12 8.5 12C8.22386 12 8 11.7761 8 11.5V10H6.5C6.22386 10 6 9.77614 6 9.5C6 9.22386 6.22386 9 6.5 9H8V7.5C8 7.22386 8.22386 7 8.5 7Z",
    fill: "#FF6E40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempLabour);
export default __webpack_public_path__ + "static/media/temp-labour.0ee244c04843e5468382f56bdb45e3aa.svg";
export { ForwardRef as ReactComponent };